// -------------------------------------------------------------------------------------------------
// NortonLifeLock copyright header start
// ----------------------
//
// PROPRIETARY / CONFIDENTIAL.
// Use of this product is subject to license terms.
// Copyright (c) 2022 NortonLifeLock
// All rights reserved.
//
// -------------------------------------------------------------------------------------------------
// NortonLifeLock copyright header stop
// ----------------------
import React, { useEffect } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import {
  OnboardStep,
  BulletPoint,
  AaIcon,
  PageContent,
  Title,
  Heading,
  BulletContainer,
} from '../../components';
import { useGraphic, useMessagePolling } from '../../hooks';
import { OnboardImage } from '../../const';
import { isIphone } from '../../utils';
import emptypuzzle from '../../assets/images/puzzle-empty.webp';
import styled from 'styled-components';

const PageContainer = styled(PageContent)`
  img {
    transform: translateY(0.1875rem);
    margin-right: 0.1875rem;
    margin-left: 0.1875rem;
  }
`;

export const AllowStatePage = () => {
  const { t } = useTranslation();
  const { getLocalizedGraphic } = useGraphic();
  const { startMessagePolling, stopMessagePolling } = useMessagePolling();

  useEffect(() => {
    startMessagePolling();

    return () => {
      stopMessagePolling();
    };
  }, []);

  return (
    <PageContainer>
      <Title>{t('Step N of 2', { step: 2 })}</Title>
      <Heading>{t('Allow AntiTrack to block trackers')}</Heading>
      <BulletContainer>
        <OnboardStep image={getLocalizedGraphic(OnboardImage.STEP3)}>
          <BulletPoint number='3'>
            {isIphone() ? (
              <Trans t={t} i18nKey='TapNortonAntiTrack'>
                Tap <AaIcon />, then Norton AntiTrack in the Safari address bar.
              </Trans>
            ) : (
              <Trans t={t} i18nKey='TapNortonAntiTrack'>
                Tap <img src={emptypuzzle} alt='empty-puzzle-icon' />, then Norton AntiTrack in the
                Safari address bar.
              </Trans>
            )}
          </BulletPoint>
        </OnboardStep>
        <OnboardStep image={getLocalizedGraphic(OnboardImage.STEP4)}>
          <BulletPoint number='4'>{t('Tap Always Allow.')}</BulletPoint>
        </OnboardStep>
        <OnboardStep image={getLocalizedGraphic(OnboardImage.STEP5)}>
          <BulletPoint number='5'>{t('Tap Always Allow on Every Website.')}</BulletPoint>
        </OnboardStep>
      </BulletContainer>
    </PageContainer>
  );
};
